import { useEffect, useState } from "react";
import api from "../../lib/api";
import { fmtDate, inrFull, pct } from "../../lib/format";
import { Empty } from "../kit";

const Row = ({ x, showStaff, main, sub, testid }) => (
  <div className="bs-card p-4 flex items-center justify-between gap-3" data-testid={testid}>
    <div>
      <div className="font-semibold text-[#011E38]">{x.customer_name}</div>
      <div className="text-xs text-slate-500">{fmtDate(x.date)}{x.plan_ref && ` · ${x.plan_ref}`}{showStaff && ` · ${x.staff_name}`}{x.remarks && ` · ${x.remarks}`}</div>
    </div>
    <div className="text-right"><div className="num font-bold text-lg text-[#011E38]">{main}</div><div className="text-xs text-slate-500">{sub}</div></div>
  </div>
);

export default function GmsEntries({ kind, filters, range, showStaff, reloadKey }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/gms/entries", { params: { start: range.start, end: range.end, ...filters } }).then((r) => setD(r.data)); }, [filters, range, reloadKey]);
  if (!d) return null;
  const rows = kind === "reenroll" ? d.reenrollments : d.upsells;
  if (!rows.length) return <Empty>No {kind === "reenroll" ? "re-enrollments" : "upselling entries"} in this period.</Empty>;
  return (
    <div className="grid md:grid-cols-2 gap-3" data-testid={`gms-${kind}-list`}>
      {rows.map((x) => kind === "reenroll" ? (x.status === "not_reenrolled" ? (
        <Row key={x.id} x={x} showStaff={showStaff} testid={`gms-reenroll-row-${x.id}`} main={<span className="text-red-700 text-sm">NOT RE-ENROLLED</span>}
          sub={`Previous ${inrFull(x.prev_monthly)} → ₹0 · 0%`} />
      ) :
        <Row key={x.id} x={x} showStaff={showStaff} testid={`gms-reenroll-row-${x.id}`} main={`${inrFull(x.prev_monthly)} → ${inrFull(x.new_monthly)}`}
          sub={`${pct(x.reenroll_pct, 0)} · +${inrFull(x.increase)} (${pct(x.increase_pct, 0)})`} />
      ) : (
        <Row key={x.id} x={x} showStaff={showStaff} testid={`gms-upsell-row-${x.id}`} main={`+${inrFull(x.upsell_value)}`}
          sub={`${inrFull(x.matured_value)} → ${inrFull(x.sale_value)} · ${pct(x.upsell_pct, 0)}`} />
      ))}
    </div>
  );
}
